const initialState = {
    noData: false,
    reports: [],
    fetching: false,
    fetched: false,
    error: null,
    percent_complete: 0,
    complete_export: false,
}

export function rankingReportsReducer(state = initialState, action) {

    switch (action.type) {

        case "FETCH_REPORTS": {
            return { ...state, fetching: true, fetched: false, error: null }
        }

        case "FETCH_REPORTS_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }

        case "FETCH_REPORTS_FULFILLED": {
            var mth = action.payload.data.salaryMonth.toString().substr(4)
            var year = action.payload.data.salaryMonth.toString().substr(0,4)

            if (mth == "01")
                mth = "January"
            else if (mth == "02")
                mth = "February"
            else if (mth == "03")
                mth = "March"
            else if (mth == "04")
                mth = "April"
            else if (mth == "05")
                mth = "May"
            else if (mth == "06")
                mth = "June"
            else if (mth == "07")
                mth = "July"
            else if (mth == "08")
                mth = "August"
            else if (mth == "09")
                mth = "September"
            else if (mth == "10")
                mth = "October"
            else if (mth == "11")
                mth = "November"
            else if (mth == "12")
                mth = "December"

            action.payload.data.salaryMonthDisplay = " " + mth + " " + year + " Year to Date"

            return { ...state, fetching: false, fetched: true, noData: action.payload.data.rankingReports.length == 0, reports: action.payload.data }
        }

        case "FETCH_REPORTS_ERROR": {
            return { ...state, error: null }
        }
        case "NODATA_ERROR_CLEAR": {
            return { ...state, noData: false }
        }

        case "EXPORT_EXCEL_RANKING_REPORTS": {
            return { ...state, fetching: false, fetched: true, filter: action.payload.data }
        }
        case "PERCENTAGE_COMPLETE_RANKING_REPORTS": {
            return { ...state, fetching: false, fetched: true, percent_complete: action.payload.data }
        }
        case "EXPORT_START_RANKING_REPORTS": {
            return { ...state, fetching: false, fetched: true, complete_export: action.payload.data }
        }
        case "FINISH_EXPORT_RANKING_REPORTS": {
            return { ...state, fetching: false, fetched: true, percent_complete: action.payload.data }
        }
        case "COMPLETE_EXPORT_RANKING_REPORTS": {
            return { ...state, fetching: false, fetched: true, complete_export: action.payload.data }
        }    
        default:
            return state
    }
}